import Login from '@/pages/auth/login.vue';
import GrooveBlog from '@/pages/grooveblog.vue';
import GrooveCalendar from '@/pages/groovecalendar.vue';
import GrooveDesk from '@/pages/groovedesk.vue';
import GrooveSurvey from '@/pages/groovesurvey.vue';
import GrooveWebinars from '@/pages/groovewebinars.vue';
import GrooveKart from '@/pages/groovekart.vue';
import GroovePagesForShopify from '@/pages/groovepages-for-shopify.vue';
import GrooveAffiliatesMarketplace from '@/pages/groove-affiliates-marketplace.vue';
import GrooveMarketplace from '@/pages/groove-market-place.vue';
import GrooveAppStore from '@/pages/groove-app-store.vue';
import GrooveApiDocs from '@/pages/groove-api-docs.vue';
import GrooveDevelopers from '@/pages/groove-developers.vue';
import GroovePay from '@/pages/groovepay.vue';
import GrooveAds from '@/pages/grooveads.vue';
import GrooveCopyPro from '@/pages/groovecopypro.vue';
import LiveEvents from '@/pages/grooveliveevents.vue';
import MarketersCruise from '@/pages/groovecruise.vue';
import Tutorials from '@/pages/groovetutorials.vue';
import Academy from '@/pages/grooveacademy.vue';
import TheGrooveBlog from '@/pages/thegrooveblog.vue';
import PartnerProgram from '@/pages/partnerprogram.vue';

export default [
  {
    path: '/',
    name: 'welcome',
    component: GrooveBlog,
    meta: {
      pageTitle: 'GrooveBlog',
      rule: 'guest'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      rule: 'guest'
    }
  },
  {
    path: '/partner-program',
    name: 'partners',
    component: PartnerProgram,
    meta: {
      rule: 'guest'
    }
  },
  {
    path: '/grooveblog',
    name: 'grooveblog',
    component: GrooveBlog,
    meta: {
      pageTitle: 'GrooveBlog',
      rule: 'guest'
    }
  },
  {
    path: '/groovewebinars',
    name: 'groovewebinars',
    component: GrooveWebinars,
    meta: {
      pageTitle: 'GrooveWebinars',
      rule: 'guest'
    }
  },
  {
    path: '/groovedesk',
    name: 'groovedesk',
    component: GrooveDesk,
    meta: {
      pageTitle: 'GrooveDesk',
      rule: 'guest'
    }
  },
  {
    path: '/groovesurvey',
    name: 'groovesurvey',
    component: GrooveSurvey,
    meta: {
      pageTitle: 'GrooveSurvey',
      rule: 'guest'
    }
  },
  {
    path: '/groovecalendar',
    name: 'groovecalendar',
    component: GrooveCalendar,
    meta: {
      pageTitle: 'GrooveCalendar',
      rule: 'guest'
    }
  },
  {
    path: '/groovekart',
    name: 'groovekart',
    component: GrooveKart,
    meta: {
      pageTitle: 'GrooveKart',
      rule: 'guest'
    }
  },
  {
    path: '/groovepages-for-shopify',
    name: 'groovepages-for-shopify',
    component: GroovePagesForShopify,
    meta: {
      pageTitle: 'GroovePages For Shopify',
      rule: 'guest'
    }
  },
  {
    path: '/grooveaffiliatemarketplace',
    name: 'grooveaffiliatemarketplace',
    component: GrooveAffiliatesMarketplace,
    meta: {
      pageTitle: 'Affiliate Marketplace',
      rule: 'guest'
    }
  },
  {
    path: '/groovemarketplace',
    name: 'groovemarketplace',
    component: GrooveMarketplace,
    meta: {
      pageTitle: 'Groove Marketplace',
      rule: 'guest'
    }
  },
  {
    path: '/grooveappstore',
    name: 'grooveappstore',
    component: GrooveAppStore,
    meta: {
      pageTitle: 'Multi-Vendor Marketplace',
      rule: 'guest'
    }
  },
  {
    path: '/grooveapidocs',
    name: 'grooveapidocs',
    component: GrooveApiDocs,
    meta: {
      pageTitle: 'API Docs',
      rule: 'guest'
    }
  },
  {
    path: '/groovedevelopers',
    name: 'groovedevelopers',
    component: GrooveDevelopers,
    meta: {
      pageTitle: 'App Developers',
      rule: 'guest'
    }
  },
  {
    path: '/groovepay',
    name: 'groovepay',
    component: GroovePay,
    meta: {
      pageTitle: 'GroovePay',
      rule: 'guest'
    }
  },
  {
    path: '/grooveads',
    name: 'grooveads',
    component: GrooveAds,
    meta: {
      pageTitle: 'GrooveAds',
      rule: 'guest'
    }
  },
  {
    path: '/groovecopypro',
    name: 'groovecopypro',
    component: GrooveCopyPro,
    meta: {
      pageTitle: 'GrooveCopyPro',
      rule: 'guest'
    }
  },
  {
    path: '/grooveliveevents',
    name: 'grooveliveevents',
    component: LiveEvents,
    meta: {
      pageTitle: 'Live Events',
      rule: 'guest'
    }
  },
  {
    path: '/groovecruise',
    name: 'groovecruise',
    component: MarketersCruise,
    meta: {
      pageTitle: 'The Marketers Cruise',
      rule: 'guest'
    }
  },
  {
    path: '/grooveacademy',
    name: 'grooveacademy',
    component: Academy,
    meta: {
      pageTitle: 'GrooveDigital Academy',
      rule: 'guest'
    }
  },
  {
    path: '/groovetutorials',
    name: 'groovetutorials',
    component: Tutorials,
    meta: {
      pageTitle: 'Tutorials',
      rule: 'guest'
    }
  },
  {
    path: '/groovethegrooveblog',
    name: 'groovethegrooveblog',
    component: TheGrooveBlog,
    meta: {
      pageTitle: 'Blog',
      rule: 'guest'
    }
  }
];
